import React, { Component } from 'react'
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from 'react-router-dom'

import Header from './components/Header'
import ComponentPage from './pages/ComponentPage'
import HomePage from './pages/HomePage'

export default class App extends Component {
  render() {
    return (
      <Router>
        <Header name="Bnt Design" />
        <Switch>
          <Redirect exact from="/list" to="/components/modal" />
          <Route exact path="/" component={HomePage} />
          <Route path="/components/:id" component={ComponentPage} />
          <Route path="*">
            <div>Not Found</div>
          </Route>
        </Switch>
      </Router>
    )
  }
}
